// Normalizes an empty string to `undefined` before passing it to a DevExtreme control.
// DevExtreme treats `''` as "set, and empty", so a control with a RequiredRule reports a broken rule as soon as it
// mounts, causing fields to show red before the user had typed anything.
// Strings only; don't use for numbers, e.g. `0 || undefined` would collapse a legitimate zero to blank.
export const asInput = (value: string | null | undefined): string | undefined => value || undefined;
